import { Component, inject, Input, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { CommonModule, NgClass } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { ordersFeature, OrdersActions } from '../../../store/order.store';
import { lastValueFrom, take } from 'rxjs';


@Component({
  selector: 'msh-side-drawer',
  imports: [MatIconModule, MatButtonModule, NgClass, CommonModule],
  animations: [
    trigger('drawerState', [
      state('closed', style({ transform: 'translateX(100%)' })),
      state('open', style({ transform: 'translateX(0)' })),
      transition('closed <=> open', animate('300ms ease-in-out'))
    ])
  ],
  template: `
    <!-- Drawer Container -->
    <div 
      class="fixed bg-back md:top-0 top-12 right-0 mt-14 z-10 rounded-bl-md flex items-start"
      [@drawerState]="isOpen() ? 'open' : 'closed'"
      [class.shadow-xl]="isOpen()"
    >

      <!-- Drawer Panel -->
      <div 
        class="h-full border-l border-b border-copy/70"
        style="max-width: 500px; max-width: 80vw;"
      >
        <!-- Toggle Button -->
        <div
          (click)="toggleDrawer()"
          class="absolute -left-8 top-4 bg-back border rounded-full shadow 
                w-10 h-10 flex items-center justify-center hover:bg-copy hover:text-back transition cursor-pointer"
          [ngClass]="{'-left-4': isOpen(), 'left-4': isHidden || cartCount() === 0}"
        >
          <mat-icon>
            {{ isOpen() ? 'close' : 'shopping_cart' }}
          </mat-icon>
          @if ( !isOpen() && (cartCount() && (cartCount() || 0) > 0)) {
            <span class=" bg-back -left-6 top-0  bubble"
            >{{ cartCount() }}</span>
          }
        </div>  
        <ng-content></ng-content>
      </div>


    </div>
  `,
  styles: [``]
})
export class SideDrawerComponent {
  @Input() isHidden = false;
  cartCount = toSignal(inject(Store).select(ordersFeature.selectCartCount), { initialValue: 0 });
  isOpen = toSignal(inject(Store).select(ordersFeature.selectSideCartOpen));
  constructor(
    private store: Store,
  ){}
  async toggleDrawer() {
    console.log({isOpen: this.isOpen()})
    this.store.dispatch(OrdersActions.toggleSideCart({ isOpen: null}))
    const state = await lastValueFrom(this.store.select(ordersFeature.selectSideCartOpen).pipe(take(1)))
    console.log({state})
  }
}
